<template>
    <v-app id="inspire">
        <YesNoModal ref="YesNoModal" />
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <Loader ref="Loader"></Loader>
        <v-content>
            <v-img style="position:fixed; width:100%; height:100%;" position="100% 100%" src="Attraction/Login.jpeg"
                gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"></v-img>
            <v-container justify-center>
                <Loader ref="Loader"></Loader>
                <ErrorModal ref="ErrorModal"></ErrorModal>
                <v-stepper v-model="e1">
                    <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1"> {{TranslateText('Account Details')}}</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="e1 > 2" step="2"> {{TranslateText('Personal Details')}}</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="e1 > 2" step="3"> {{TranslateText('Login Details')}}</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="4"> {{TranslateText('Account Overview')}}</v-stepper-step>
                    </v-stepper-header>

                    <!-- ACCOUNT DETAILS -->
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-form ref="formAccount" v-model="validAccountDetails">
                                <v-container>
                                    <v-layout column>
                                        <v-flex xs6>
                                            <v-checkbox v-model="form.AccountForm.AccountDetails.MasterAccess" v-if="containsMaster = false"
                                                :label="TranslateText('Master Account')" required></v-checkbox>
                                            <v-layout column>
                                                <v-flex xs4 md1>
                                                    <v-avatar slot="offset" class="mx-auto d-block" size="130">
                                                        <v-img v-model="form.AccountForm.AccountDetails.CompanyLogo"
                                                            @click="addFile" @mouseover="imageHover" @mouseout="imageHoverDone"
                                                            :class="{ 'image-overlay': showOverlay }" style="width: 100%; border-radius: 50%;"
                                                            aspect-ratio="1" class="grey lighten-2" :src="imageUrl">
                                                        </v-img>
                                                    </v-avatar>
                                                </v-flex>
                                                <br>
                                                <!-- <v-text-field v-model="form.AccountForm.AccountDetails.CompanyLogo"
                                                    :label="TranslateText('Company Logo')"></v-text-field> -->
                                                <v-text-field :rules="fieldRules" v-model="form.AccountForm.AccountDetails.CompanyName"
                                                    :label="TranslateText('Company Name')" required></v-text-field>
                                                <v-layout xs12 sm12 md6 lg6 xl6 justify-start row>
                                                    <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                        <v-combobox :label="TranslateText('Country Code')" v-model="form.AccountForm.AccountDetails.CountryCode"
                                                            :items="Countries" :rules="fieldRules" required />
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                        <v-text-field v-model="form.AccountForm.AccountDetails.City"
                                                            :label="TranslateText('City')" required :rules="fieldRules"></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-text-field v-model="form.AccountForm.AccountDetails.StreetAddress"
                                                    :label="TranslateText('Street Address')" required :rules="fieldRules"></v-text-field>
                                                <v-layout xs12 sm12 md6 lg6 xl6 justify-start row>
                                                    <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                        <v-text-field v-model="form.AccountForm.AccountDetails.PhoneNumber"
                                                            :label="TranslateText('Contact Telephone Number')" mask="phone"
                                                            required :rules="fieldRules"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                        <v-text-field v-model="form.AccountForm.AccountDetails.EmailAddress"
                                                            :label="TranslateText('Contact Email Address')" required
                                                            :rules="emailRules"></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-layout>

                                            <v-checkbox v-model="form.AccountForm.AccountDetails.UseUnits" :label="TranslateText('Use Units')"
                                                required></v-checkbox>

                                            <v-text-field v-model="form.AccountForm.AccountDetails.NumberOfUnits" type="number"
                                                :label="TranslateText('Number of Units')" :disabled="!form.AccountForm.AccountDetails.UseUnits"></v-text-field>
                                            <v-checkbox v-model="form.AccountForm.AccountDetails.UseSeats" :label="TranslateText('Use Seats')"
                                                required></v-checkbox>
                                            <v-layout xs12 sm12 md6 lg6 xl6 justify-start row>
                                                <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                    <v-text-field v-model="form.AccountForm.AccountDetails.AccountBaseCost"
                                                        type="number" :label="TranslateText('Account Base Cost')"
                                                        :disabled="!form.AccountForm.AccountDetails.UseSeats"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                    <v-text-field v-model="form.AccountForm.AccountDetails.AccountSeatCost"
                                                        type="number" :label="TranslateText('Account Seat Cost')"
                                                        :disabled="!form.AccountForm.AccountDetails.UseSeats"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <input @change="readURL" style="display: none" ref="fileInput" type="file">
                                    </v-layout>
                                    <div class="text-xs-right">

                                        <v-btn color="primary" @click="e1 = 2" :disabled="!validAccountDetails">
                                            {{TranslateText('Continue')}}</v-btn>
                                        <v-btn flat @click="$router.push('/login')">{{TranslateText('Cancel')}}</v-btn>
                                    </div>
                                </v-container>
                            </v-form>
                        </v-stepper-content>

                        <!-- PERSONAL DETAILS -->
                        <v-stepper-content step="2">
                            <v-form ref="formPersonal" v-model="validPersonalDetails">
                                <v-container>
                                    <v-layout xs12 sm12 md4 lg4 xl4 justify-start row>
                                        <v-flex xs12 sm12 md4 lg4 xl4 mr-2>
                                            <v-text-field :label="TranslateText('Title')" v-model="form.SystemUserForm.PersonalDetails.Title"
                                                :rules="fieldRules" required></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md4 lg4 xl4 mr-2>
                                            <v-text-field :label="TranslateText('Firstname')" v-model="form.SystemUserForm.PersonalDetails.FirstName"
                                                :rules="fieldRules" required></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md4 lg4 xl4>
                                            <v-text-field :label="TranslateText('Lastname')" v-model="form.SystemUserForm.PersonalDetails.LastName"
                                                :rules="fieldRules" required></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-text-field v-model="form.SystemUserForm.PersonalDetails.CompanyPosition" :label="TranslateText('Company Position')"
                                        :rules="fieldRules" required></v-text-field>
                                    <v-layout xs12 sm12 md6 lg6 xl6 justify-start row>
                                        <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                            <v-text-field v-model="form.SystemUserForm.PersonalDetails.ContactTel"
                                                :label="TranslateText('Contact Telephone Number')" mask="phone"
                                                required :rules="fieldRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                            <v-text-field v-model="form.SystemUserForm.PersonalDetails.ContactEmail"
                                                :label="TranslateText('Contact Email Address')" required :rules="emailRules"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-text-field v-model="form.SystemUserForm.PersonalDetails.AddressLine1" :label="TranslateText('Address Line 1')"
                                        :rules="fieldRules" required></v-text-field>
                                    <v-text-field v-model="form.SystemUserForm.PersonalDetails.AddressLine2" :label="TranslateText('Address Line 2')"></v-text-field>
                                    <v-layout xs12 sm12 md6 lg6 xl6 justify-start row>
                                        <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                            <v-text-field v-model="form.SystemUserForm.PersonalDetails.Suburb" :label="TranslateText('Suburb')"
                                                required :rules="fieldRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                            <v-text-field v-model="form.SystemUserForm.PersonalDetails.Province" :label="TranslateText('Province')"
                                                :rules="fieldRules" required></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <div class="text-xs-right">
                                        <v-btn color="primary" @click="e1 = 3" :disabled="!validPersonalDetails">
                                            {{TranslateText('Continue')}}</v-btn>
                                        <v-btn flat @click="e1 = 1"> {{TranslateText('Previous')}}</v-btn>
                                    </div>
                                </v-container>
                            </v-form>
                        </v-stepper-content>

                        <!-- LOGIN DETAILS -->
                        <v-stepper-content step="3">
                            <v-form ref="formLogin" v-model="validLoginDetails">
                                <v-container>
                                    <v-layout column class="mb-5">
                                        <v-flex class="ml-2">
                                            <v-text-field v-model="form.SystemUserForm.PersonalDetails.Username" :label="TranslateText('Username')"
                                                required :rules="fieldRules"></v-text-field>
                                            <v-layout xs12 sm12 md6 lg6 xl6 justify-start row>
                                                <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                    <v-text-field v-model="form.SystemUserForm.PersonalDetails.Password"
                                                        type="password" :label="TranslateText('Password')" required
                                                        :rules="fieldRules"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                                                    <v-text-field v-model="ConfirmedPassword" type="password" :label="TranslateText('Confirm Password')"
                                                        required :rules="fieldRules" @blur="comparePasswords()"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <div class="text-xs-right">

                                        <v-btn color="primary" @click="e1 = 4" :disabled="!validLoginDetails">
                                            {{TranslateText('Continue')}}</v-btn>
                                        <v-btn flat @click="e1 = 2"> {{TranslateText('Previous')}}</v-btn>
                                    </div>
                                </v-container>
                            </v-form>
                        </v-stepper-content>

                        <!-- ACCOUNT OVERVIEW -->
                        <v-stepper-content step="4">
                            <v-form ref="formOverview" @submit.prevent="SubmitForm">
                                <v-container>
                                    <v-card elevation="4">
                                        <v-layout column class="mb-5">
                                            <v-flex class="ml-2">
                                                <v-layout xs12 sm12 md6 lg6 xl6 justify-start row>
                                                    <v-flex xs12 sm12 md4 lg4 xl4 mr-2>
                                                        <h3><u><b>Account Details</b></u></h3>
                                                        <br>
                                                        <p><b>Company Name:</b> {{
                                                            form.AccountForm.AccountDetails.CompanyName }}</p>
                                                        <p><b>City:</b> {{ form.AccountForm.AccountDetails.City }}</p>
                                                        <p><b>Address:</b> {{
                                                            form.AccountForm.AccountDetails.StreetAddress
                                                            }}</p>
                                                        <p><b>Email Address:</b> {{
                                                            form.AccountForm.AccountDetails.EmailAddress }}</p>
                                                        <p><b>Telephone Number:</b> {{
                                                            form.AccountForm.AccountDetails.PhoneNumber
                                                            }}</p>
                                                        <p><b>Use Units:</b> {{
                                                            form.AccountForm.AccountDetails.UseUnits }}</p>
                                                        <p><b>Use Seats:</b> {{
                                                            form.AccountForm.AccountDetails.UseSeats
                                                            }}</p>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md4 lg4 xl4 mr-2>
                                                        <h3><u><b>Personal Details</b></u></h3>
                                                        <br>
                                                        <p><b>Fullname:</b> {{
                                                            form.SystemUserForm.PersonalDetails.FirstName }} {{
                                                            form.SystemUserForm.PersonalDetails.LastName }} </p>
                                                        <p><b>Suburb:</b> {{ form.SystemUserForm.PersonalDetails.Suburb
                                                            }}</p>
                                                        <p><b>Address:</b> {{
                                                            form.SystemUserForm.PersonalDetails.AddressLine1 }},
                                                            {{ form.SystemUserForm.PersonalDetails.AddressLine2 }}</p>
                                                        <p><b>Email Address:</b> {{
                                                            form.SystemUserForm.PersonalDetails.ContactEmail }}</p>
                                                        <p><b>Telephone Number:</b> {{
                                                            form.SystemUserForm.PersonalDetails.ContactTel
                                                            }}</p>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md4 lg4 xl4 mr-2>
                                                        <h3><u><b>Login Details</b></u></h3>
                                                        <p><b>Username:</b> {{
                                                            form.SystemUserForm.PersonalDetails.Username
                                                            }} </p>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <div class="text-xs-right">

                                            <v-btn color="primary" type="submit"> {{TranslateText('Register')}}</v-btn>
                                            <v-btn flat @click="e1 = 3"> {{TranslateText('Previous')}}</v-btn>
                                        </div>
                                    </v-card>
                                </v-container>
                            </v-form>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-container>
        </v-content>
        <v-footer app dark inset fixed color="darkgray">
            <v-spacer></v-spacer>
            <div>Powered by DevInspire (Pty) Ltd. &copy; {{ new Date().getFullYear() }}</div>
        </v-footer>
    </v-app>
</template>

<script>
    const countryList = require('country-list');

    export default {
        data() {
            let self = this;

            return {
                fieldRules: [
                    v => !!v || "Field is required",
                ],
                emailRules: [
                    v => !!v || "E-mail is required",
                    v => /.+@.+/.test(v) || "E-mail must be valid"
                ],
                e1: 0,
                validAccountDetails: false,
                validPersonalDetails: false,
                validLoginDetails: false,
                form: {
                    AccountForm: {
                        AccountDetails: {
                            CompanyLogo: "",
                            CompanyName: "",
                            CountryCode: "",
                            City: "",
                            StreetAddress: "",
                            PhoneNumber: "",
                            EmailAddress: "",
                            UseUnits: false,
                            NumberOfUnits: null,
                            UseSeats: false,
                            AccountBaseCost: null,
                            AccountSeatCost: null,
                            MasterAccess: false,
                        }
                    },
                    SystemUserForm: {
                        PersonalDetails: {
                            Title: "",
                            CompanyPosition: "",
                            FirstName: "",
                            LastName: "",
                            ContactTel: "",
                            ContactEmail: "",
                            AddressLine1: "",
                            AddressLine2: "",
                            Suburb: "",
                            Province: "",
                            Username: "",
                            Password: "",
                        }
                    },
                },
                ConfirmedPassword: "",
                containsMaster: false,
                CountryName: null,
                Countries: null,
                showOverlay: false,
                file: null,
                imageUrl: ""
            }
        },
        mounted() {
            let self = this;

            self.getRoles();
            self.getCountries();
        },
        methods: {
            comparePasswords() {
                let self = this;

                if (self.form.SystemUserForm.PersonalDetails.Password != self.ConfirmedPassword) {
                    self.validLoginDetails = false;
                    self.$refs.ErrorModal.show();
                    self.$refs.ErrorModal.setText("Passwords do not match!");

                    setTimeout(function () {
                        self.$refs.ErrorModal.hide();
                    }, 1000)
                }
            },
            SubmitForm() {
                let self = this;

                var systemUserDetails = self.form.SystemUserForm.PersonalDetails;
                var accountDetails = self.form.AccountForm.AccountDetails;

                accountDetails.NumberOfUnits = parseInt(self.form.AccountForm.AccountDetails.NumberOfUnits);
                // accountDetails.AccountBaseCost = parseFloat(self.form.AccountForm.AccountDetails.AccountBaseCost);
                // accountDetails.AccountSeatCost = parseFloat(self.form.AccountForm.AccountDetails.AccountSeatCost);

                // account user details for blank entries
                if (self.form.AccountForm.AccountDetails.PhoneNumber == "" || self.form.AccountForm.AccountDetails.PhoneNumber ==
                    null) {
                    self.form.AccountForm.AccountDetails.PhoneNumber = self.form.SystemUserForm.PersonalDetails.ContactTel;
                }

                if (self.form.AccountForm.AccountDetails.StreetAddress == "" || self.form.AccountForm.AccountDetails.StreetAddress ==
                    null) {
                    self.form.AccountForm.AccountDetails.StreetAddress = self.form.SystemUserForm.PersonalDetails.AddressLine1 +
                        ', ' + self.form.SystemUserForm.PersonalDetails.AddressLine2;
                }

                if (self.form.AccountForm.AccountDetails.EmailAddress == "" || self.form.AccountForm.AccountDetails.EmailAddress ==
                    null) {
                    self.form.AccountForm.AccountDetails.EmailAddress = self.form.SystemUserForm.PersonalDetails.ContactEmail;
                }

                if (self.form.AccountForm.AccountDetails.City == "" || self.form.AccountForm.AccountDetails.City ==
                    null) {
                    self.form.AccountForm.AccountDetails.City = self.form.SystemUserForm.PersonalDetails.Suburb;
                }

                // system user details for blank entries
                if (self.form.SystemUserForm.PersonalDetails.ContactEmail == "" || self.form.SystemUserForm.PersonalDetails
                    .ContactEmail == null) {
                    self.form.SystemUserForm.PersonalDetails.ContactEmail = self.form.AccountForm.AccountDetails.EmailAddress;
                }

                if (self.form.SystemUserForm.PersonalDetails.ContactTel == "" || self.form.SystemUserForm.PersonalDetails
                    .ContactTel == null) {
                    self.form.SystemUserForm.PersonalDetails.ContactTel = self.form.AccountForm.AccountDetails.PhoneNumber;
                }

                if (self.form.SystemUserForm.PersonalDetails.Suburb == "" || self.form.SystemUserForm.PersonalDetails.Suburb ==
                    null) {
                    self.form.SystemUserForm.PersonalDetails.Suburb = self.form.AccountForm.AccountDetails.City;
                }

                if (self.form.SystemUserForm.PersonalDetails.Province == "" || self.form.SystemUserForm.PersonalDetails
                    .Province == null) {
                    self.form.SystemUserForm.PersonalDetails.Province = self.form.AccountForm.AccountDetails.City;
                }

                if (self.form.SystemUserForm.PersonalDetails.ContactEmail == "" || self.form.SystemUserForm.PersonalDetails
                    .ContactEmail == null) {
                    self.form.SystemUserForm.PersonalDetails.ContactEmail = self.form.AccountForm.AccountDetails.EmailAddress;
                }

                let Request = {
                    Account: accountDetails,
                    SystemUser: systemUserDetails
                }
                console.log(systemUserDetails)
                console.log(accountDetails)

                self.$refs.Loader.show();
                self.post("Registration/Save", Request, false)
                    .then(res => {
                        self.$refs.Loader.hide();
                        self.$refs.SuccessModal.show(); // success modal
                        self.$refs.SuccessModal.setText("Account has been registered!");

                        setTimeout(function () {
                            self.$refs.SuccessModal.hide();
                            self.$router.push('/login');
                        }, 800)
                    })
                    .catch(err => {
                        console.log(err);
                        self.$refs.Loader.hide()
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText("Failed to register account");
                    });
            },
            getRoles() {
                let self = this;

                self.$refs.Loader.show(true);
                self.get('Registration/Account/Master', null, false)
                    .then(response => {
                        self.$refs.Loader.hide();
                        self.containsMaster = response.data;
                        //console.log(self.containsMaster)
                    })
                    .catch(error => {
                        self.$refs.Loader.hide();
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(error.toString());
                    })
            },
            imageHover() {
                let self = this;
                self.showOverlay = true;
            },
            imageHoverDone() {
                let self = this;
                self.showOverlay = false;
            },
            addFile() {
                let self = this;
                self.$refs.fileInput.click();
            },
            readURL(e) {
                let self = this;
                self.blobToDataURL(e.target.files[0], function (dataurl) {
                    self.imageUrl = dataurl;
                    self.blobToArrayBuffer(e.target.files[0], function (result) {
                        self.form.AccountForm.AccountDetails.CompanyLogo = Array.from(new Uint8Array(
                            result));
                        console.log(self.form.AccountForm.AccountDetails.CompanyLogo)
                    });

                })
            },
            blobToArrayBuffer(blob, callback) {
                var a = new FileReader();
                a.onload = function (e) {
                    callback(a.result);
                }
                a.readAsArrayBuffer(blob);
            },
            blobToDataURL(blob, callback) {
                var a = new FileReader();
                a.onload = function (e) {
                    callback(e.target.result);
                }
                a.readAsDataURL(blob);
                console.log(blob)
            },
            getCountries() {
                let self = this;

                self.Countries = countryList.getCodes();
            },
        },

    }
</script>

<style scoped>
    .image-overlay {
        cursor: pointer;
        opacity: 0.1;
    }
</style>